import Swiper from '@iris.interactive/handcook/public/scripts/libraries/swiper-11'

export default class PageComponent {
    constructor() {
        $('#galerie-open-button').on('click', () => {
            PageComponent.getGalleryData()
            $('#galerie-modal').addClass('open')
            return false
        })
        $('#video-open-button').on('click', () => {
            PageComponent.getVideoData()
            $('#video-modal').addClass('open')
            return false
        })
        $('#map-open-button').on('click', () => {
            PageComponent.getMapData()
            $('#map-modal').addClass('open')
            return false
        })
    }

    static getGalleryData() {
        const pageId = $('#galerie-modal').data('page-id')

        $.ajax({
            url: IRISCollectionTheme.ajaxUrl,
            data: {
                action: 'get_gallery_modal',
                datas: {
                    page_id: pageId,
                },
            },
            method: 'POST',
        }).done((response) => {
            $('#galerie-modal').html(response)
            PageComponent.renderModal('#galerie-modal')
        })
    }

    static getVideoData() {
        const pageId = $('#video-modal').data('page-id')

        $.ajax({
            url: IRISCollectionTheme.ajaxUrl,
            data: {
                action: 'get_video_modal',
                datas: {
                    page_id: pageId,
                },
            },
            method: 'POST',
        }).done((response) => {
            $('#video-modal').html(response)
            PageComponent.renderModal('#video-modal')
        })
    }

    static getMapData() {
        const pageId = $('#map-modal').data('page-id')

        $.ajax({
            url: IRISCollectionTheme.ajaxUrl,
            data: {
                action: 'get_map_modal',
                datas: {
                    page_id: pageId,
                },
            },
            method: 'POST',
        }).done((response) => {
            $('#map-modal').html(response)
            PageComponent.renderModal('#map-modal')
            $(document).trigger('iris-map/map/load')
            PageComponent.filterMap()
        })
    }

    static renderModal(element) {
        $('.custom-modal .close').on('click', () => {
            $('.custom-modal').removeClass('open')
        })

        PageComponent.gallerySwiper(element)
        $(element).removeClass('loading')
    }

    static async gallerySwiper(element) {
        const swiper = await Swiper.create(`${element} .small-swiper`, {
            spaceBetween: 10,
            slidesPerView: 'auto',
            freeMode: true,
            watchSlidesProgress: true,
            mousewheel: {
                forceToAxis: true,
            },
        })
        const swiper2 = await Swiper.create(`${element} .large-swiper`, {
            spaceBetween: 10,
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
            },
            thumbs: {
                swiper: swiper,
            },
        })
    }

    static filterMap() {
        $('.filters-map__filter').on('click', function () {
            const filterId = $(this).data('filter-id')
            if ($(this).hasClass('checked')) {
                $(this).removeClass('checked')
                $(`[data-item-filter=${filterId}]`).hide()
                $(`[data-marker=${filterId}]`).hide()
            } else {
                $(this).addClass('checked')
                $(`[data-item-filter=${filterId}]`).show()
                $(`[data-marker=${filterId}]`).show()
            }
        })
    }
}
